<template>
  <div>
    <b-row>
      <b-col>
        <b-card>
          <div slot="header">
            <strong>
              Transporter Master (Registered)
            </strong>
            <div class="card-header-actions">
              <!-- <button class="btn btn-sm btn-primary mr-4 btn-pill" type="button"
              @click="toggleTransporterInfo" :disabled="isReadOnly">
              Add New
              </button> -->
            </div>
          </div>
          <b-row>
            <b-col sm="12">
              <div>
                <b-card v-if="addInfoCard">
                  <b-form @submit.prevent="addTransporterForm('form-1')" data-vv-scope="form-1">
                    <b-row>
                      <b-col sm="6">
                        <b-form-group>
                          <label for="Company Name">
                            Company Name
                          </label>
                          &nbsp;
                          <span style="color: red;">
                            *
                          </span>
                          <b-form-input type="text" name="Company Name" v-model="transporterObj.transporter_company_name"
                          v-validate="'required|min:3|max:50'" :class="{ input: true, 'is-invalid': errors.has('form-1.Company Name'),
                          }" placeholder="Enter Company Name">
                          </b-form-input>
                          <b-input-group class="mb-3">
                            <span class="icon has-text-warning">
                              <i class="fa fa-warning help text-danger" v-show="errors.has('form-1.Company Name')">
                                {{ errors.first("form-1.Company Name") }}
                              </i>
                            </span>
                          </b-input-group>
                        </b-form-group>
                      </b-col>
                      <b-col sm="6">
                        <b-form-group>
                          <label for="Owner Name">
                            Company Owner Name
                          </label>
                          &nbsp;
                          <span style="color: red;">
                            *
                          </span>
                          <b-form-input type="text" name="Owner Name" v-model="transporterObj.transporter_name"
                          v-validate="'required|min:3|max:30'" :class="{ input: true, 'is-invalid': errors.has('form-1.Owner Name'),
                          }" placeholder="Enter Company Owner Name">
                          </b-form-input>
                          <b-input-group class="mb-3">
                            <span class="icon has-text-warning">
                              <i class="fa fa-warning help text-danger" v-show="errors.has('form-1.Owner Name')">
                                {{ errors.first("form-1.Owner Name") }}
                              </i>
                            </span>
                          </b-input-group>
                        </b-form-group>
                      </b-col>
                      <b-col sm="6">
                        <b-form-group>
                          <label for="Email Id">
                            Company Email Id
                          </label>
                          &nbsp;
                          <span style="color: red;">
                            *
                          </span>
                          <b-form-input type="text" name="Email Id" v-model="transporterObj.transporter_emailid"
                          v-validate="'required|email'" :class="{ input: true, 'is-invalid': errors.has('form-1.Email Id'),
                          }" placeholder="Enter Company Email Id">
                          </b-form-input>
                          <b-input-group class="mb-3">
                            <span class="icon has-text-warning">
                              <i class="fa fa-warning help text-danger" v-show="errors.has('form-1.Email Id')">
                                {{ errors.first("form-1.Email Id") }}
                              </i>
                            </span>
                          </b-input-group>
                        </b-form-group>
                      </b-col>
                      <b-col sm="6">
                        <b-form-group>
                          <label for="Mobile Number">
                            Company Mobile Number
                          </label>
                          &nbsp;
                          <span style="color: red;">
                            *
                          </span>
                          <b-form-input type="text" name="Mobile Number" v-model="transporterObj.transporter_mobilenumber"
                          v-validate="'required|digits:10'" :class="{ input: true, 'is-invalid': errors.has('form-1.Mobile Number'),
                          }" maxlength="10" placeholder="Enter Company Mobile Number">
                          </b-form-input>
                          <b-input-group class="mb-3">
                            <span class="icon has-text-warning">
                              <i class="fa fa-warning help text-danger" v-show="errors.has('form-1.Mobile Number')">
                                {{ errors.first("form-1.Mobile Number") }}
                              </i>
                            </span>
                          </b-input-group>
                        </b-form-group>
                      </b-col>
                      <b-col sm="6">
                        <b-form-group>
                          <label for="Password">
                            Password
                          </label>
                          &nbsp;
                          <span style="color: red;">
                            *
                          </span>
                          <b-form-input name="Password" type="password" minlength="6" maxlength="14"
                          v-model="transporterObj.password" v-validate="'required|min:6|max:14'"
                          :class="{ input: true, 'is-invalid': errors.has('form-1.Password'),
                          }" placeholder="Enter Password">
                          </b-form-input>
                          <b-input-group class="mb-3">
                            <span class="icon has-text-warning">
                              <i class="fa fa-warning help text-danger" v-show="errors.has('form-1.Password')">
                                {{ errors.first("form-1.Password") }}
                              </i>
                            </span>
                          </b-input-group>
                        </b-form-group>
                      </b-col>
                      <b-col sm="6">
                        <b-row>
                          <b-col :sm="!transporterObj.gstnumber?12:9" :class="transporterObj.gstnumber!=''?'pr-0':'pr-3'">
                            <b-form-group>
                              <label for="GSTNumber">
                                Tin Number / GST Number
                              </label>
                              <b-form-input name="GST Number" type="text" v-model="transporterObj.gstnumber"
                              @input="checkGSTlength(transporterObj.gstnumber)" placeholder="Enter Tin Number / GST Number"
                              :class="{ input: true, 'is-invalid': errors_GST,
                              }">
                              </b-form-input>
                              <b-input-group class="mb-3">
                                <span class="icon has-text-warning">
                                  <i class="fa fa-warning" v-show="errors.has('GST Number')">
                                  </i>
                                </span>
                                <code v-show="errors.has('form-1.GST Number')" id="GST Number" class="help text-danger">
                                  {{ errors.first("form-1.GST Number") }}
                                </code>
                              </b-input-group>
                            </b-form-group>
                          </b-col>
                          <b-col :sm="!transporterObj.gstnumber?0:3" class="mt-1 pr-0">
                            <button type="button" class="btn btn-outline-success btn-md mt-4" v-if="addshowverifybutton"
                            @click="verifyGSTNo()">
                              Verify
                            </button>
                            &nbsp;
                            <button type="button" class="btn btn-outline-danger btn-md mt-4" v-if="removeGST"
                            @click="removevalue()">
                              X
                            </button>
                          </b-col>
                        </b-row>
                      </b-col>
                      <b-col sm="6">
                        <b-form-group>
                          <label for="Transport Serviceability">
                            Transport Serviceability
                          </label>
                          &nbsp;
                          <span style="color: red;">
                            *
                          </span>
                          <b-form-select class="mb-3" name="Transport Serviceability" v-model="transporterObj.transportserviceability"
                          v-validate="'required|'" :class="{ input: true, 'is-invalid': errors.has('form-1.Transport Serviceability'),
                          }">
                            <option :value="selected">
                              Please select an option
                            </option>
                            <option value="local">
                              Local
                            </option>
                            <option value="state">
                              State
                            </option>
                            <option value="regional">
                              Regional
                            </option>
                            <option value="national">
                              National
                            </option>
                          </b-form-select>
                          <b-input-group class="mb-3">
                            <span class="icon has-text-warning">
                              <i class="fa fa-warning help text-danger" v-show="errors.has('form-1.Transport Serviceability')">
                                {{ errors.first("form-1.Transport Serviceability") }}
                              </i>
                            </span>
                          </b-input-group>
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <footer class="column has-text-right">
                      <b-button variant="primary" size="md" type="submit" id="submitButton">
                        Add
                      </b-button>
                    </footer>
                  </b-form>
                </b-card>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="4">
              <b-form-group label-cols-md="2" label="Filter" class="mb-0">
                <b-input-group>
                  <b-form-input v-model="filter" placeholder="Enter Id/Name" class="w-60">
                  </b-form-input>
                  <!-- <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input> -->
                  <b-col sm="4">
                    <b-button @click="getTransporterList()" size="md" variant="primary">
                      Search
                    </b-button>
                  </b-col>
                  &nbsp;
                  <b-button @click="clearSearch()" size="md" variant="danger">
                    Clear
                  </b-button>
                  <!-- <b-button @click="getTransporterList()" size="sm" variant="primary">Search</b-button>
                  <b-button :disabled="!filter" @click="filter = ''"
                  >Clear</b-button> -->
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col sm="5">
              <b-form-group label-cols-sm="4" label="Approval Level:" class="mb-0">
                <b-form-select v-model="selectedApprovalLevel" @change="handleFilterChange">
                  <option value="">
                    All Levels
                  </option>
                  <option value="1">
                    L1
                  </option>
                  <option value="2">
                    L2
                  </option>
                  <option value="3">
                    L3
                  </option>
                </b-form-select>
              </b-form-group>
            </b-col>
            <b-col sm="3" class="text-right">
              <p>
                <b>
                  Total Records :
                  <span style="color:red;">
                    {{totalRows}}
                  </span>
                </b>
              </p>
            </b-col>
            <b-col sm="12">
              <b-table show-empty responsive :items="transporter_data" :busy="isBusy"
               :fields="fields" :per-page="perPage" 
              :bordered="bordered">
                <div slot="table-busy" class="text-center text-danger my-2">
                  <b-spinner class="align-middle">
                  </b-spinner>
                  <strong>
                    Loading...
                  </strong>
                </div>
                <template slot="isactive" slot-scope="row">
                  <span @click="toggleInfoModal(row.item)" style="cursor:pointer;">
                    <span data-toggle="tooltip" title="InActive" v-if="row.item.isactive === '0'">
                      <span class="badge badge-danger">
                        Inative
                      </span>
                    </span>
                    <span data-toggle="tooltip" title="Active" v-else>
                      <span class="badge badge-success">
                        Active
                      </span>
                    </span>
                  </span>
                </template>
               
                <template slot="createddate" slot-scope="row">
                  <div>
                    {{ row.item.createddate | ConvertTime12hour() }}
                  </div>
                </template>
                <template slot="tingstnumber" slot-scope="row">
                  <div>
                   {{ (!row.item.transporter_gst_no || row.item.transporter_gst_no === 'undefined') ? '-' : row.item.transporter_gst_no }}

                  </div>
                </template>
                <template slot="lastmodifieddate" slot-scope="row">
                  <div>
                    {{ row.item.lastmodifieddate | ConvertTime12hour() }}
                  </div>
                </template>
                <template slot="invoice_status" slot-scope="row">
                  {{ formatStatus(row.item) }}
                </template>
                   <template slot="vehicle_count" slot-scope="row">
                    <b-button variant="primary" size="sm" @click="getVehicleForTransporterID(row.item.transporter_id,row.item.transporter_name)">
                      {{row.item.vehicle_count}}
                    </b-button>
                </template>
               <template slot="action" slot-scope="row">
                  <div class="action-buttons">
                    <b-button variant="info" size="sm" @click="openViewModal(row.item)">
                      View
                    </b-button>
                    <b-button variant="warning" size="sm" @click="updateModal(row.item)" :disabled="isReadOnly">
                      Edit
                    </b-button>
                   
                    <b-button variant="primary" size="sm" @click="transporterMasterLog(row.item.transporter_id)">
                      Log
                    </b-button>
                  </div>
                </template>

              </b-table>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6" class="my-1" v-if="totalRows>20">
            <b-pagination
                  v-if="totalRows > perPage"
                  v-model="currentPage"
                  :total-rows="totalRows"
                  :per-page="perPage"
                  @change="getTransporterList"
                ></b-pagination>

              
            </b-col>
          </b-row>
          <b-modal title="Update Transporter Info" size="lg" v-model="updateInfo"
          @ok="updateInfo==false" hide-footer>
            <b-row>
              <b-col sm="12">
                <b-form @submit.prevent="editTransporterForm('form-1')" data-vv-scope="form-1">
                  <b-row>
                    <b-col sm="6">
                      <b-form-group>
                        <label for="vendortype">
                          Type of Vendor
                        </label>
                        <span style="color: red;">
                          *
                        </span>
                        <b-form-radio-group id="vendor type" v-model="updatetransporterObj.vendortype"
                        v-validate="'required'" :options="[
                        { text: 'Aggregator', value: 'aggregator' }, 
                        { text: 'Normal', value: 'normal' }
                        ]" name="vendor type" :class="{input: true,'is-invalid': errors.has('form-1.vendor type'),}">
                        </b-form-radio-group>
                        <b-input-group class="mb-3">
                          <span class="icon has-text-warning">
                            <i class="fa fa-warning help text-danger" v-show="errors.has('form-1.vendor type')">
                              {{ errors.first("form-1.vendor type") }}
                            </i>
                          </span>
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                    <b-col sm="6">
                      <b-form-group>
                        <label for="Company Name">
                          Company Name
                        </label>
                        &nbsp;
                        <span style="color: red;">
                          *
                        </span>
                        <b-form-input type="text" name="Company Name" v-model="updatetransporterObj.transporter_company_name"
                        v-validate="'required|min:3|max:50'" disabled :class="{ input: true, 'is-invalid': errors.has('form-1.Company Name'),
                        }" placeholder="Enter Company Name">
                        </b-form-input>
                        <b-input-group class="mb-3">
                          <span class="icon has-text-warning">
                            <i class="fa fa-warning help text-danger" v-show="errors.has('form-1.Company Name')">
                              {{ errors.first("form-1.Company Name") }}
                            </i>
                          </span>
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                    <b-col sm="6">
                      <b-form-group>
                        <label for="Owner Name">
                          Company Owner Name
                        </label>
                        &nbsp;
                        <span style="color: red;">
                          *
                        </span>
                        <b-form-input type="text" name="Owner Name" v-model="updatetransporterObj.transporter_name"
                        v-validate="'required|min:3|max:30'" :class="{ input: true, 'is-invalid': errors.has('form-1.Owner Name'),
                        }" placeholder="Enter Company Owner Name">
                        </b-form-input>
                        <b-input-group class="mb-3">
                          <span class="icon has-text-warning">
                            <i class="fa fa-warning help text-danger" v-show="errors.has('form-1.Owner Name')">
                              {{ errors.first("form-1.Owner Name") }}
                            </i>
                          </span>
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                    <b-col sm="6">
                      <b-form-group>
                        <label for="Email Id">
                          Company Email Id
                        </label>
                        &nbsp;
                        <span style="color: red;">
                          *
                        </span>
                        <b-form-input type="text" name="Email Id" v-model="updatetransporterObj.transporter_emailid"
                        v-validate="'required|email'" disabled :class="{ input: true, 'is-invalid': errors.has('form-1.Email Id'),
                        }" placeholder="Enter Company Email Id">
                        </b-form-input>
                        <b-input-group class="mb-3">
                          <span class="icon has-text-warning">
                            <i class="fa fa-warning help text-danger" v-show="errors.has('form-1.Email Id')">
                              {{ errors.first("form-1.Email Id") }}
                            </i>
                          </span>
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                    <b-col sm="6">
                      <b-form-group>
                        <label for="Mobile Number">
                          Company Mobile Number
                        </label>
                        &nbsp;
                        <span style="color: red;">
                          *
                        </span>
                        <b-form-input type="text" name="Mobile Number" v-model="updatetransporterObj.transporter_mobilenumber"
                        v-validate="'required|digits:10'" :class="{ input: true, 'is-invalid': errors.has('form-1.Mobile Number'),
                        }" maxlength="10" placeholder="Enter Company Mobile Number">
                        </b-form-input>
                        <b-input-group class="mb-3">
                          <span class="icon has-text-warning">
                            <i class="fa fa-warning help text-danger" v-show="errors.has('form-1.Mobile Number')">
                              {{ errors.first("form-1.Mobile Number") }}
                            </i>
                          </span>
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                    <b-col sm="6">
                      <b-form-group>
                        <label for="GSTNumber">
                          Tin Number / GST Number
                        </label>
                        <b-form-input name="GST Number" type="text" v-validate="'required|max:50'"
                        v-model="updatetransporterObj.gstnumber" @input="updatecheckGSTlength(updatetransporterObj.gstnumber)"
                        placeholder="Enter Tin Number / GST Number" disabled :class="{ input: true, 'is-invalid': update_errors_GST,
                        }">
                        </b-form-input>
                        <b-input-group class="mb-3">
                          <span class="icon has-text-warning" v-if="update_errors_GST">
                            <i class="fa fa-warning help text-danger">
                              {{ update_errors_showGST.transporter_gstnumber }}
                            </i>
                          </span>
                        </b-input-group>
                      </b-form-group>
                      <button type="button" class="btn btn-outline-success btn-md" v-if="showverifybutton"
                      @click="updateverifyGSTNo()">
                        Verify
                      </button>
                      &nbsp;
                      <button type="button" class="btn btn-outline-danger btn-md" v-if="update_removeGST"
                      @click="updateremovevalue()">
                        X
                      </button>
                    </b-col>
                    <b-col sm="6">
                      <b-form-group>
                        <label for="GSTNumber">
                          Change password
                        </label>
                        <b-form-input name="GST Number" type="text" v-model="updatetransporterObj.password"
                        placeholder="Enter Change password">
                        </b-form-input>
                        <!-- <b-input-group class="mb-3">
                        <span class="icon has-text-warning" v-if="update_errors_GST">
                        <i
                        class="fa fa-warning help text-danger"
                        >{{ update_errors_showGST.transporter_gstnumber }}</i
                        >
                        </span>
                        </b-input-group> -->
                      </b-form-group>
                    </b-col>
                    <!-- <b-col sm="6" class="mt-1">
                    <button type="button" class="btn btn-outline-success btn-md mt-4" v-if="showverifybutton" @click="updateverifyGSTNo()">Verify</button>&nbsp;
                    <button type="button" class="btn btn-outline-danger btn-md mt-4" v-if="update_removeGST" @click="updateremovevalue()">X</button>
                    </b-col> -->
                    <b-col sm="6">
                      <b-form-group>
                        <label for="Transport Serviceability">
                          Transport Serviceability
                        </label>
                        &nbsp;
                        <span style="color: red;">
                          *
                        </span>
                        <b-form-select class="mb-3" name="Transport Serviceability" v-model="updatetransporterObj.transportserviceability"
                        v-validate="'required|'" :class="{ input: true, 'is-invalid': errors.has('form-1.Transport Serviceability'),
                        }">
                          <option :value="null">
                            Please select an option
                          </option>
                          <option value="local">
                            Local
                          </option>
                          <option value="state">
                            State
                          </option>
                          <option value="regional">
                            Regional
                          </option>
                          <option value="national">
                            National
                          </option>
                        </b-form-select>
                        <b-input-group class="mb-3">
                          <span class="icon has-text-warning">
                            <i class="fa fa-warning help text-danger" v-show="errors.has('form-1.Transport Serviceability')">
                              {{ errors.first("form-1.Transport Serviceability") }}
                            </i>
                          </span>
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                    <!-- <b-col sm="6">
                    <b-form-group>
                    <label for="promotername">Promoter Name</label>&nbsp;<span style="color: red;">*</span>
                    <b-input-group class="mb-3">
                    <b-form-input class="input" type="text" id="promoter name" name="promoter name" v-model="updatetransporterObj.promotername" v-validate="'required|max:50'" :class="{
                    input: true,'is-invalid': errors.has('form-1.promoter name'),}" placeholder="Enter Promoter Name"></b-form-input>
                    </b-input-group>
                    <b-input-group class="mb-3">
                    <span class="icon has-text-warning">
                    <i
                    class="fa fa-warning help text-danger"
                    v-show="errors.has('form-1.promoter name')"
                    >{{ errors.first("form-1.promoter name") }}</i
                    >
                    </span>
                    </b-input-group>
                    </b-form-group>
                    </b-col> -->
                    <b-col sm="6">
                      <b-form-group>
                        <label for="panno">
                          PAN
                        </label>
                        &nbsp;
                        <span style="color: red;">
                          *
                        </span>
                        <b-input-group class="mb-3">
                          <b-form-input class="input" type="text" id="pan number" name="pan number"
                          v-model="updatetransporterObj.pan" v-validate="'required|max:50'" :class="{
                          input: true,'is-invalid': errors.has('form-1.pan number'),}" placeholder="Enter PAN Number">
                          </b-form-input>
                        </b-input-group>
                        <b-input-group class="mb-3">
                          <span class="icon has-text-warning">
                            <i class="fa fa-warning help text-danger" v-show="errors.has('form-1.pan number')">
                              {{ errors.first("form-1.pan number") }}
                            </i>
                          </span>
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                    <b-col sm="6">
                      <b-form-group>
                        <label for="adhaarno">
                          Aadhaar
                        </label>
                        &nbsp;
                        <span style="color: red;">
                          *
                        </span>
                        <b-input-group class="mb-3">
                          <b-form-input class="input" type="text" id="adhaar number" name="adhaar number"
                          v-model="updatetransporterObj.aadhar" v-validate="'required|max:50'" :class="{
                          input: true,'is-invalid': errors.has('form-1.adhaar number'),}" placeholder="Enter Aadhaar Number">
                          </b-form-input>
                        </b-input-group>
                        <b-input-group class="mb-3">
                          <span class="icon has-text-warning">
                            <i class="fa fa-warning help text-danger" v-show="errors.has('form-1.adhaar number')">
                              {{ errors.first("form-1.adhaar number") }}
                            </i>
                          </span>
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                    <b-col sm="6">
                      <b-form-group>
                        <label for="bankcancelledcheque">
                          Bank Cancelled Cheque
                        </label>
                        &nbsp;
                        <span style="color: red;">
                          *
                        </span>
                        <div class="d-flex align-items-center">
                          <b-form-file type="file" v-model="updatetransporterObj.bankcancelledcheque"
                          placeholder="Bank Cancelled Cheque" @change="selectBankChequeFile($event)"
                          class="custom-border" v-validate="'required'" id="bank cancelled cheque"
                          name="bank cancelled cheque" :class="{
                          input: true,'is-invalid': errors.has('form-1.bank cancelled cheque'),}">
                            <template v-slot:file-name>
                              {{ bankFileName }}
                            </template>
                          </b-form-file>
                          <b-button variant="primary" class="ms-3" @click="downloadFile(updatetransporterObj.bankcancelledcheque)"
                          v-b-tooltip.hover="'Download File'">
                            <i class="fa fa-download">
                            </i>
                          </b-button>
                        </div>
                        <b-input-group class="mb-3">
                          <span class="icon has-text-warning">
                            <i class="fa fa-warning help text-danger" v-show="errors.has('form-1.bank cancelled cheque')">
                              {{ errors.first("form-1.bank cancelled cheque") }}
                            </i>
                          </span>
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                    <b-col sm="6">
                      <b-form-group>
                        <label for="gstincertificate">
                          GSTIN Certificate
                        </label>
                        &nbsp;
                        <div class="d-flex align-items-center">
                          <b-form-file type="file" v-model="updatetransporterObj.gstincertificate"
                          placeholder="GSTIN Certificate" @change="selectGstinCertficateFile($event)"
                          class="custom-border" id="gstin certficate" name="gstin certficate" :class="{
                          input: true,'is-invalid': errors.has('form-1.gstin certficate'),}">
                            <template v-slot:file-name>
                              {{ gstinCertficateFilename }}
                            </template>
                          </b-form-file>
                          <b-button variant="primary" class="ms-3" @click="downloadFile(updatetransporterObj.gstincertificate)"
                          v-b-tooltip.hover="'Download File'">
                            <i class="fa fa-download">
                            </i>
                          </b-button>
                        </div>
                      </b-form-group>
                    </b-col>
                    <b-col sm="6">
                      <b-form-group>
                        <label for="pincode">
                          Pincode
                        </label>
                        &nbsp;
                        <v-select v-model="updatetransporterObj.pincode" :options="pincodes" placeholder="-- Select Pincode --"
                        @change="pincodeChange(updatetransporterObj.pincode)">
                        </v-select>
                        <b-input-group class="mb-3">
                          <span style="width:240px" v-show="errors.has('form-1.pincode')" class="help text-danger">
                            {{ errors.first("form-1.pincode") }}
                          </span>
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                    <b-col sm="6">
                      <b-form-group>
                        <label for="address">
                          Address
                        </label>
                        &nbsp;
                        <span style="color: red;">
                          *
                        </span>
                        <b-input-group class="mb-3">
                          <b-form-input class="input" v-validate="'required'" type="text" id="address"
                          name="address" v-model="updatetransporterObj.address" :class="{
                          input: true,'is-invalid': errors.has('form-1.address'),}" placeholder="Enter Address">
                          </b-form-input>
                        </b-input-group>
                        <b-input-group class="mb-3">
                          <span class="icon has-text-warning">
                            <i class="fa fa-warning help text-danger" v-show="errors.has('form-1.address')">
                              {{ errors.first("form-1.address") }}
                            </i>
                          </span>
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                    <b-col sm="6" v-if="updatetransporterObj.pincode">
                      <b-form-group>
                        <label for="city">
                          City
                        </label>
                        &nbsp;
                        <b-input-group class="mb-3">
                          <b-form-input class="input" type="text" id="city" name="city" v-model="updatetransporterObj.city"
                          :class="{
                          input: true,'is-invalid': errors.has('form-1.city'),}" placeholder="">
                          </b-form-input>
                        </b-input-group>
                        <b-input-group class="mb-3">
                          <span class="icon has-text-warning">
                            <i class="fa fa-warning" v-show="errors.has('city')">
                            </i>
                          </span>
                          <code v-show="errors.has('form-1.city')" id="addresserrmsg" class="help text-danger">
                            {{ errors.first("form-1.address") }}
                          </code>
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                    <b-col sm="6" v-if="updatetransporterObj.pincode">
                      <b-form-group>
                        <label for="state">
                          State
                        </label>
                        &nbsp;
                        <b-input-group class="mb-3">
                          <b-form-input class="input" type="text" id="state" name="state" v-model="updatetransporterObj.state"
                          :class="{
                          input: true,'is-invalid': errors.has('form-1.state'),}" placeholder="">
                          </b-form-input>
                        </b-input-group>
                        <b-input-group class="mb-3">
                          <span class="icon has-text-warning">
                            <i class="fa fa-warning" v-show="errors.has('state')">
                            </i>
                          </span>
                          <code v-show="errors.has('form-1.state')" id="addresserrmsg" class="help text-danger">
                            {{ errors.first("form-1.state") }}
                          </code>
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                    <b-col sm="6">
                      <b-form-group>
                        <label for="bankname">
                          Bank name
                        </label>
                        &nbsp;
                        <span style="color: red;">
                          *
                        </span>
                        <b-input-group class="mb-3">
                          <b-form-input class="input" v-validate="'required'" type="text" id="bankname"
                          name="bankname" v-model="updatetransporterObj.bankname" :class="{
                          input: true,'is-invalid': errors.has('form-1.bankname'),}" placeholder="Enter Bank name">
                          </b-form-input>
                        </b-input-group>
                        <b-input-group class="mb-3">
                          <span class="icon has-text-warning">
                            <i class="fa fa-warning help text-danger" v-show="errors.has('form-1.bankname')">
                              {{ errors.first("form-1.bankname") }}
                            </i>
                          </span>
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                    <b-col sm="6">
                      <b-form-group>
                        <label for="bankaccountname">
                          Bank Account Name
                        </label>
                        &nbsp;
                        <span style="color: red;">
                          *
                        </span>
                        <b-input-group class="mb-3">
                          <b-form-input class="input" type="text" v-validate="'required'" id="bankaccountname"
                          name="bankaccountname" v-model="updatetransporterObj.bankaccountname" :class="{
                          input: true,'is-invalid': errors.has('form-1.bankaccountname'),}" placeholder="Enter Bank Account Name">
                          </b-form-input>
                        </b-input-group>
                        <b-input-group class="mb-3">
                          <span class="icon has-text-warning">
                            <i class="fa fa-warning help text-danger" v-show="errors.has('form-1.bankaccountname')">
                              {{ errors.first("form-1.bankaccountname") }}
                            </i>
                          </span>
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                    <b-col sm="6">
                      <b-form-group>
                        <label for="branchname">
                          Branch Name
                        </label>
                        &nbsp;
                        <span style="color: red;">
                          *
                        </span>
                        <b-input-group class="mb-3">
                          <b-form-input class="input" type="text" v-validate="'required'" id="branchname"
                          name="branchname" v-model="updatetransporterObj.branchname" :class="{
                          input: true,'is-invalid': errors.has('form-1.branchname'),}" placeholder="Enter Branch Name">
                          </b-form-input>
                        </b-input-group>
                        <b-input-group class="mb-3">
                          <span class="icon has-text-warning">
                            <i class="fa fa-warning help text-danger" v-show="errors.has('form-1.branchname')">
                              {{ errors.first("form-1.branchname") }}
                            </i>
                          </span>
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                    <b-col sm="6">
                      <b-form-group>
                        <label for="accountnumber">
                          Account number
                        </label>
                        &nbsp;
                        <span style="color: red;">
                          *
                        </span>
                        <b-input-group class="mb-3">
                          <b-form-input class="input" v-validate="'required'" type="text" id="accountnumber"
                          name="accountnumber" v-model="updatetransporterObj.accountnumber" :class="{
                          input: true,'is-invalid': errors.has('form-1.accountnumber'),}" placeholder="Enter Account number">
                          </b-form-input>
                        </b-input-group>
                        <b-input-group class="mb-3">
                          <span class="icon has-text-warning">
                            <i class="fa fa-warning help text-danger" v-show="errors.has('form-1.accountnumber')">
                              {{ errors.first("form-1.accountnumber") }}
                            </i>
                          </span>
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                    <b-col sm="6">
                      <b-form-group>
                        <label for="ifsccode">
                          IFSC Code
                        </label>
                        &nbsp;
                        <span style="color: red;">
                          *
                        </span>
                        <b-input-group class="mb-3">
                          <b-form-input class="input" v-validate="'required'" type="text" id="ifsccode"
                          name="ifsccode" v-model="updatetransporterObj.ifsccode" :class="{
                          input: true,'is-invalid': errors.has('form-1.ifsccode'),}" placeholder="Enter IFSC Code">
                          </b-form-input>
                        </b-input-group>
                        <b-input-group class="mb-3">
                          <span class="icon has-text-warning">
                            <i class="fa fa-warning help text-danger" v-show="errors.has('form-1.ifsccode')">
                              {{ errors.first("form-1.ifsccode") }}
                            </i>
                          </span>
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <footer class="column has-text-right">
                    <div id="overlayModal">
                      <div class="loaderModal">
                      </div>
                    </div>
                    <div class="text-right">
                      <b-button variant="primary" size="md" type="submit" id="submitButton1">
                        Update
                      </b-button>
                    </div>
                  </footer>
                </b-form>
              </b-col>
            </b-row>
          </b-modal>
          <!-- Transporter Log Popup Modal -->
          <b-modal ref="transporterLogModal" title="Transporter Log Details" hide-footer
          size="xl">
            <div id="listloader" v-if="loader">
              <div class="listloader">
              </div>
              <br/>
              <span class="loading" style="color:#fff;">
                Loading...
              </span>
            </div>
            <div>
              <table class="table table-bordered mt-3">
                <thead>
                  <tr>
                    <th>
                      Sr.no
                    </th>
                    <th>
                      Transporter ID
                    </th>
                    <th>
                      Status
                    </th>
                    <th>
                      Createdby
                    </th>
                    <th>
                      User Approval Level
                    </th>
                    <th>
                      Total Approval Levels
                    </th>
                    <th>
                      Reject Reason
                    </th>
                    <th>
                      Created Date
                    </th>
                  </tr>
                </thead>
                <tbody v-if="arrTransporterLog.length > 0">
                  <tr v-for="(item, index) in arrTransporterLog" :key="index">
                    <td>
                      {{(index+1)}}
                    </td>
                    <td>
                      {{ item.transporter_id }}
                    </td>
                    <td>
                      {{ item.status }}
                    </td>
                    <td>
                      {{ item.createdby }}
                    </td>
                    <td>
                      {{ item.user_approval_level }}
                    </td>
                    <td>
                      {{ item.total_approval_levels }}
                    </td>
                    <td>
                      {{ item.reject_reason||'-' }}
                    </td>
                    <td>
                      {{ formatDate(item.createdat) }}
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td colspan="8">
                      Records Not Created By Transporter
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <!-- Footer with Approve and Reject with Remark Buttons -->
            <div class="text-right mt-3" v-if="arrTransporterLog.length > 0">
              <b-button variant="secondary" @click="$refs.transporterLogModal.hide()">
                Close
              </b-button>
            </div>
          </b-modal>
          <!-- Confirmation Box -->
          <b-modal title="Confirmation Box" v-model="toggleInfo" size="md" @ok="toggleInfo =false">
            <template slot="modal-header" slot-scope="{ close }">
              <h5>
                Confirmation Box
              </h5>
            </template>
            <template slot="default" slot-scope="{ hide }">
              <form v-on:submit.prevent="activateinactivateTransporter(value)">
                <div class="modal-background">
                </div>
                <div class="modal-card">
                  <section class="modal-card-body">
                    <input type="hidden" v-model="customer.isactive" name="isactive" id="modalIsActiveChk"
                    />
                    <span>
                      Are you sure you want to change the status?
                    </span>
                  </section>
                  <footer>
                    <b-button variant="primary" size="sm" type="submit">
                      Ok
                    </b-button>
                  </footer>
                </div>
              </form>
            </template>
            <template slot="modal-footer" slot-scope="{ cancel }">
              <!-- Emulate built in modal footer ok and cancel button actions -->
              <b-button size="sm" variant="danger" @click="cancel()">
                Cancel
              </b-button>
            </template>
          </b-modal>
          <b-modal id="view-transporter-modal" size="xl" title="Transporter Details" >
            <div v-if="selectedTransporter">
                <b-container fluid>
                  <!-- General Info -->
                  <h5 class="mt-2">General Info</h5>
                  <b-row>
                    <b-col sm="4"><strong>ID:</strong></b-col>
                    <b-col sm="8">{{ selectedTransporter.transporter_id }}</b-col>
                  </b-row>
                  <b-row>
                    <b-col sm="4"><strong>Name:</strong></b-col>
                    <b-col sm="8">{{ selectedTransporter.transporter_name }}</b-col>
                  </b-row>
                  <b-row>
                    <b-col sm="4"><strong>Company:</strong></b-col>
                    <b-col sm="8">{{ selectedTransporter.transporter_company_name }}</b-col>
                  </b-row>
                  <b-row>
                    <b-col sm="4"><strong>Status:</strong></b-col>
                    <b-col sm="8">
                      <b-badge :variant="selectedTransporter.isactive === '1' ? 'success' : 'danger'">
                        {{ selectedTransporter.isactive === '1' ? 'Active' : 'Inactive' }}
                      </b-badge>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col sm="4"><strong>Approval Status:</strong></b-col>
                    <b-col sm="8">{{ selectedTransporter.approver_status }}</b-col>
                  </b-row>
                  <b-row>
                    <b-col sm="4"><strong>Serviceability:</strong></b-col>
                    <b-col sm="8">{{ selectedTransporter.serviceability }}</b-col>
                  </b-row>
                  <b-row>
                    <b-col sm="4"><strong>Vendor Type:</strong></b-col>
                    <b-col sm="8">{{ selectedTransporter.vendortype }}</b-col>
                  </b-row>

                  <!-- Contact Info -->
                  <h5 class="mt-3">Contact Info</h5>
                  <b-row>
                    <b-col sm="4"><strong>Email:</strong></b-col>
                    <b-col sm="8">{{ selectedTransporter.transporter_emailid }}</b-col>
                  </b-row>
                  <b-row>
                    <b-col sm="4"><strong>Mobile:</strong></b-col>
                    <b-col sm="8">{{ selectedTransporter.transporter_mobilenumber }}</b-col>
                  </b-row>
                  <b-row>
                    <b-col sm="4"><strong>Address:</strong></b-col>
                    <b-col sm="8">{{ selectedTransporter.address }}</b-col>
                  </b-row>
                  <b-row>
                    <b-col sm="4"><strong>City:</strong></b-col>
                    <b-col sm="8">{{ selectedTransporter.city || '-' }}</b-col>
                  </b-row>
                  <b-row>
                    <b-col sm="4"><strong>State:</strong></b-col>
                    <b-col sm="8">{{ selectedTransporter.state || '-' }}</b-col>
                  </b-row>
                  <b-row>
                    <b-col sm="4"><strong>Pincode:</strong></b-col>
                    <b-col sm="8">{{ selectedTransporter.pincode || '-' }}</b-col>
                  </b-row>

                  <!-- Bank Info -->
                  <h5 class="mt-3">Bank Info</h5>
                  <b-row>
                    <b-col sm="4"><strong>Account Name:</strong></b-col>
                    <b-col sm="8">{{ selectedTransporter.bank_account_name }}</b-col>
                  </b-row>
                  <b-row>
                    <b-col sm="4"><strong>Bank:</strong></b-col>
                    <b-col sm="8">{{ selectedTransporter.bank_name }}</b-col>
                  </b-row>
                  <b-row>
                    <b-col sm="4"><strong>Branch:</strong></b-col>
                    <b-col sm="8">{{ selectedTransporter.bank_branch }}</b-col>
                  </b-row>
                  <b-row>
                    <b-col sm="4"><strong>Account Number:</strong></b-col>
                    <b-col sm="8">{{ selectedTransporter.account_number }}</b-col>
                  </b-row>
                  <b-row>
                    <b-col sm="4"><strong>IFSC:</strong></b-col>
                    <b-col sm="8">{{ selectedTransporter.ifsc_code }}</b-col>
                  </b-row>

                  <!-- Documents -->
                  <h5 class="mt-3">Documents</h5>
                  <b-row>
                    <b-col sm="4"><strong>PAN:</strong></b-col>
                    <b-col sm="8">{{ selectedTransporter.pan }}</b-col>
                  </b-row>
                  <b-row>
                    <b-col sm="4"><strong>Aadhaar:</strong></b-col>
                    <b-col sm="8">{{ selectedTransporter.adhaar }}</b-col>
                  </b-row>
                  <b-row>
                    <b-col sm="4"><strong>GST No:</strong></b-col>
                    <b-col sm="8">{{ (!selectedTransporter.transporter_gst_no || selectedTransporter.transporter_gst_no === 'undefined') ? '-' : selectedTransporter.transporter_gst_no }}</b-col>
                  </b-row>
                  <b-row>
                    <b-col sm="4"><strong>Cancelled Cheque:</strong></b-col>
                    <b-col sm="8">
                      <a :href="selectedTransporter.bankcancelledcheque" target="_blank">View</a>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col sm="4"><strong>GST Certificate:</strong></b-col>
                    <b-col sm="8">
                      <a :href="selectedTransporter.gstincertificate" target="_blank">View</a>
                    </b-col>
                  </b-row>

                  <!-- System Info -->
                  <h5 class="mt-3">System Info</h5>
                  <b-row>
                    <b-col sm="4"><strong>Registered From:</strong></b-col>
                    <b-col sm="8">{{ selectedTransporter.registered_from }}</b-col>
                  </b-row>
                  <b-row>
                    <b-col sm="4"><strong>No of Levels:</strong></b-col>
                    <b-col sm="8">{{ selectedTransporter.no_of_levels }}</b-col>
                  </b-row>
                  <b-row>
                    <b-col sm="4"><strong>Next Reviewer:</strong></b-col>
                    <b-col sm="8">{{ selectedTransporter.nextreviewer || '-'}}</b-col>
                  </b-row>
                  <b-row>
                    <b-col sm="4"><strong>Finbees push flag:</strong></b-col>
                    <b-col sm="8">{{ selectedTransporter.finpushflag }}</b-col>
                  </b-row>
                  <b-row>
                    <b-col sm="4"><strong>Created By:</strong></b-col>
                    <b-col sm="8">{{ selectedTransporter.createdby }}</b-col>
                  </b-row>
                  <b-row>
                    <b-col sm="4"><strong>Created Date:</strong></b-col>
                    <b-col sm="8">{{ selectedTransporter.createddate | ConvertTime12hour() }}</b-col>
                  </b-row>
                  <b-row>
                    <b-col sm="4"><strong>Last Modified By:</strong></b-col>
                    <b-col sm="8">{{ selectedTransporter.lastmodifiedby || '-' }}</b-col>
                  </b-row>
                  <b-row>
                    <b-col sm="4"><strong>Last Modified Date:</strong></b-col>
                    <b-col sm="8">{{ selectedTransporter.lastmodifieddate | ConvertTime12hour() }}</b-col>
                  </b-row>
                </b-container>
                </div>
              <div v-else class="text-center text-muted py-4">
                No data available
              </div>
                <template #modal-footer>
                  <b-button variant="secondary" @click="$bvModal.hide('view-transporter-modal')">Close</b-button>
                </template>
            
          </b-modal>
       <b-modal
  ref="vehicletransporterModal"
  id="vehicle-transporter-modal"
  size="xl"
  title="Transporter Vehicles"
  hide-footer
>
        <template #modal-title>
          Transporter Vehicles[ {{ transporterTitle }}]
        </template>
          <div v-if="arrVehiclesTransporter.length > 0">
           <b-table
          :items="arrVehiclesTransporter"
          :fields="vehicleFields"
          small
          striped
          hover
          show-empty
          responsive
        >
          <template #default></template>

         

         
        </b-table>


          </div>

          <div v-else class="text-center text-muted py-4">
            No vehicles found for this transporter.
          </div>
        </b-modal>

      </b-card>
    </b-col>
    </b-row>
  </div>
</template>
<script>
import CONSTANTS from "@/utils/constants";
import Utils from "@/utils";
import Vue from "vue";
const axios = require('axios')

export default {
    data(){
        return {
            selectedTransporter: null,
    transporterTitle: '',

         selectedApprovalLevel: "", 
            transporterObj:{
              transportserviceability:null
            },
            totalRows:0,
            fields: [
                { key: "transporter_id", label: "Vendor code", sortable: true },
                { key: "transporter_name", label: "Name", sortable: true },
                { key: "transporter_emailid", label: "Email Id", sortable: true },
                { key: "transporter_mobilenumber", label: "Mobile Number", sortable: true },
                { key: "tingstnumber", label: "GST NO", sortable: true },
                { key: "bank_name", label: "Bank Name", sortable: true },
                { key: "vehicle_count", label: "Vehicle Count", sortable: true },                
                { key: "isactive", label: "IsActive", sortable: true },
                { key: "action", label: "Actions",sortable: true},
            ],
            transporter_data:[],
            bordered: true,
            currentPage: 1,
            perPage: 20,
            pageOptions: [5, 10, 15],
            sortBy: null,
            sortDesc: false,
            sortDirection: "asc",
            filter:'',
            isBusy:false,
            addInfoCard:false,
            updateInfo:false,
            updatetransporterObj :{
              transportserviceability:null
            },
            // add
            errors_GST:false,
            errors_showGST:{},
            removeGST:false,
            addshowverifybutton:false,
            // edit
            update_errors_GST:false,
            update_errors_showGST:{},
            update_removeGST:false,
            showverifybutton:false,
            accessBody:[],
            selectedBankCheque: '',
            pincodes: [],
            pincodeCityData: [],
            bankFileName: '',
            bankcancelledcheque: '',
            bankFileType: '',
            selectedGstinCertficate: '',
            gstincertificate: '',
            gstinCertficateType: '',
            gstinCertficateFilename: '',
            isReadOnly:false,
            arrTransporterLog: [],
            tripLevelInvoiceApproval: null,
            tripLevelInvoiceApprovalLevel:'',
            toggleInfo: false,
            customer :{},
            arrVehiclesTransporter: [],
            vehicleFields: [
            { key: 'vehicle_id', label: 'Vehicle ID', sortable: false },
            { key: 'vehicle_no', label: 'Vehicle No' },
            { key: 'vehicle_name', label: 'Vehicle Name' },
            { key: 'vehicle_type', label: 'Type' },
            { key: 'driver_name', label: 'Driver Name' },
            { key: 'driver_mobile', label: 'Driver Mobile' },
            { key: 'isactive', label: 'Status' },
          ]

        }
    },
    
    created(){
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      this.accessBody = userInfo.body;
       console.log("--------->>>>>>>>>>ssss",userdata)

      console.log("--------->>>>>>>>>>userInfo",userInfo)
      if (userInfo) {
        if (userInfo && Array.isArray(userInfo.approval_action)) {
          this.tripLevelInvoiceApproval = userInfo.approval_action.find(
            action => action.module === "vendor_onboarding"
          ) || null;
        } else {
          this.tripLevelInvoiceApproval = null;
        }

       
        // Log the result (or handle it as needed)
        if (this.tripLevelInvoiceApproval && this.tripLevelInvoiceApproval.level) {
          this.tripLevelInvoiceApprovalLevel = this.tripLevelInvoiceApproval.level.replace('l', '');
          this.selectedApprovalLevel=this.tripLevelInvoiceApprovalLevel;

        }
        console.log('tripLevelInvoiceApproval Level',this.tripLevelInvoiceApprovalLevel);
      }
    console.log("--------->>>>>>>>>>",userInfo.body)
    this.ischeckbodyvalidation();
      this.currentPage=1;
        this.getTransporterList();
        this.getPincodeList();

    },
    methods:{
      toggleInfoModal: function(value) {
      this.customer = value;

      this.toggleInfo = !this.toggleInfo;
    },
openViewModal(item) {
    this.selectedTransporter = item;
    this.$bvModal.show("view-transporter-modal");
  },
    activateinactivateTransporter: function(value) {
      var activeInactiveVal;
      if (this.customer.isactive === "1") {
        activeInactiveVal = "0";
        // console.log("activeInactiveVal",activeInactiveVal);
      } else {
        activeInactiveVal = "1";
        // console.log("activeInactiveVal1",activeInactiveVal);
      }
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      const customerGetobj = {
        // deliveryagentmasterid: deliveryagentmasterId,
        transporterId: this.customer.transporter_id,
        isactive: activeInactiveVal,
        lastmodifiedby:
          `${userInfo.userfirstname}` + " " + `${userInfo.userlastname}`,
      };
      console.log("JJJJJJJJ", customerGetobj);
      // return false;
      this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/activateinactivateTransporter`,
        customerGetobj)
      .then((result) => {
        console.log("result", result);
        if (result.body.returnmsg === "Successfull") {
          // alert("Shipments are Allocated so can not InActive");
          this.$fire({
            text: "Status Changed Successfully",
            type: "success",
            timer: 30000,
          });

          this.toggleInfo = false;
          this.currentPage = 1;          
          this.getTransporterList();
        } else {
          this.$fire({
            text: result.body.returnvalue,
            type: "error",
            timer: 30000,
          });
          this.toggleInfo = false;
        }
      })
      .catch((ex) => {
        console.log("error", ex);
      });
    },
    formatStatus(item) {
      // Assuming both fields exist in the item object
      const invoiceStatus = item.approver_status || 'N/A'; // Default if null
      const nextReviewer = item.nextreviewer ? `L${item.nextreviewer}` : ''; // Prefix with 'L' if exists
      // Return values based on condition
      return nextReviewer ? `${nextReviewer} - ${invoiceStatus}` : invoiceStatus;
    },
    formatDate(date) {
      if (!date) return 'N/A'; // Fallback if date is null or undefined
      const parsedDate = new Date(date);
      return parsedDate.toLocaleDateString('en-US', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      });
    },
    transporterMasterLog(transporter_id) {   
      console.log('transporterMasterLog',transporter_id);
       this.loader = true;
      const obj = {
        transporterId: transporter_id
      };
      this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getTransporterMasterLog`, obj).then(result => {
        console.log('getTransporterMasterLog',result.body);
         this.loader = false;
        if (result.body.returnstatus === 'Successful') {
          this.arrTransporterLog = result.body.returnvalue;
        } else {
          this.arrTransporterLog = [];
        }
      }).catch(ex => {
        console.error('Error fetching invoice list:', ex);
      }).finally(() => {
        this.loader = false;
      });

      // Show dispute confirmation modal
      this.$refs.transporterLogModal.show();
    },
    getVehicleForTransporterID(transporter_id,transporter_title='') {   
      console.log('getVehicleForTransporterID',transporter_id);
      this.transporterTitle = transporter_title;
       this.loader = true;
      const obj = {
        transporterId: transporter_id
      };
      this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getVehicleForTransporterID`, obj).then(result => {
        console.log('getVehicleForTransporterID',result.body);
         this.loader = false;
        if (result.body.returnstatus === 'Successful') {
        //  this.arrVehiclesTransporter = result.body.returnvalue;
         this.arrVehiclesTransporter = result.body.returnvalue.map(item => ({
          ...item,
          detailsShowing: false
        }));
        } else {
          this.arrVehiclesTransporter = [];
        }
      }).catch(ex => {
        console.error('Error fetching invoice list:', ex);
         this.arrVehiclesTransporter = [];

      }).finally(() => {
        this.loader = false;
         this.$nextTick(() => {
          this.$refs.vehicletransporterModal.show();
        });
      });

      // Show dispute confirmation modal
      //this.$refs.vehicletransporterModal.show();
    },
      formatKey(key) {
    return key.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
  },

    rowClass(item, type) {
    return type === 'row-details' ? 'bg-light' : '';
  },
      ischeckbodyvalidation(){
            for (let i = 0; i < this.accessBody.length; i++) {
                const element = this.accessBody[i];
            
                // if (element.title=='Transporter Master' && element.isReadonly==true && this.route_id=='normal') {
                //   this.isReadOnly=true
                // }
            if (element.child) {
                for (let j = 0; j < element.child.length; j++) {
                const k = element.child[j];
                if (k.title=='Transporter Master' && k.isReadonly==true) {
                    this.isReadOnly=true
                }
                }
            }
            }
            console.log(" this.isReadOnly", this.isReadOnly)
        },
      handleFilterChange() {
        console.log("Selected Approval Level:", this.selectedApprovalLevel);
        this.tripLevelInvoiceApprovalLevel=this.selectedApprovalLevel;
          this.currentPage=1;
        this.getTransporterList();
      },
      getTransporterList(page = this.currentPage){
          this.isBusy=false;
           const approvalLevel = this.tripLevelInvoiceApprovalLevel != null ? this.tripLevelInvoiceApprovalLevel : "";
         this.currentPage = page; // Update current page
          console.log("currentPage",this.currentPage)
            const Obj = {
                page: this.currentPage, 
                pageSize: 10,
                status: "Approved",
                tripLevelInvoiceApprovalLevel:approvalLevel, 
                vehiclefilter: this.filter==null?'':this.filter,

            };
        this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getTransporterVehicledata`, Obj).then((result)=>{
            this.isBusy=false;
          if (result.body.returnmsg === "Successful") {
            this.transporter_data=result.body.returnvalue;
            this.totalRows=result.body.totalcount;
          } else {
            this.transporter_data=[];
            this.totalRows=0;
          }
        }).catch((ex) => {
          console.log("error", ex);
        });
      },

      toggleTransporterInfo(){
        this.addInfoCard = !this.addInfoCard;
        this.transporterObj={};
      },

      checkGSTlength(value){
        if (value.length>0) {
          this.addshowverifybutton=true;
          document.getElementById("submitButton").disabled = true; 
        }
        else{
          this.addshowverifybutton=false;
          this.transporterObj.gstnumber='';
          this.errors_GST = false;
          this.errors_showGST= {};
          document.getElementById("submitButton").disabled = false;
          this.removeGST=false;
        }
      },

      verifyGSTNo(){
        document.getElementById("overlay").style.display = "block";
          const infoObj = {
            Gstin:this.transporterObj.gstnumber,
          };
          console.log("infoObj",infoObj);
          this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/validateGSTNO`, infoObj).then((result)=>{
            console.log("result",result)
            document.getElementById("overlay").style.display = "none";
            if (result.body === "success") {
              document.getElementById("submitButton").disabled = false;
              this.addshowverifybutton=false;
              this.$fire({
                text: 'Successful Verify',
                type: "success",
                timer: 30000,
              });
              this.errors_GST = false;
              this.errors_showGST.transporter_gstnumber=''
              this.removeGST=false;
            } else {
              this.errors_GST = true;
              this.errors_showGST.transporter_gstnumber = 'Please Enter Valid Transporter Tin Number / GST Number';
              this.removeGST=true;
            }
          }).catch((ex) => {
            console.log("error", ex);
          });
        // if (this.transporterObj.gstnumber) {
        //   this.errors_GST = true;
        //   this.errors_showGST.transporter_gstnumber = 'Please Enter Valid Transporter Tin Number / GST Number';
        //   this.removeGST=true;
        //   return false;
        // }
        // else{
        //   document.getElementById("submitButton").disabled = false;
        // }
      },

      removevalue(){
        this.addshowverifybutton=false;
        this.transporterObj.gstnumber='';
        this.errors_GST = false;
        this.errors_showGST= {};
        document.getElementById("submitButton").disabled = false;
        this.removeGST=false;
      },

      addTransporterForm(scope){
        this.$validator.validateAll(scope).then((result) => {
          console.log("result",result)
        if (result) {
            this.addTransporterInfo();
        }
        });
      },

      addTransporterInfo(){
        document.getElementById("overlay").style.display = "block";
        let userdata = localStorage.getItem("userData");
        let userInfo = JSON.parse(userdata);
            const infoObj = {
                transporter_company_name:this.transporterObj.transporter_company_name,
                transporter_name:this.transporterObj.transporter_name,
                transporter_emailid:this.transporterObj.transporter_emailid,
                transporter_mobilenumber:this.transporterObj.transporter_mobilenumber,
                transporter_gstnumber:`${this.transporterObj.gstnumber}`,
                password:this.transporterObj.password,
                createdby:`${userInfo.sysemailid}`,
                transportserviceability:this.transporterObj.transportserviceability,
                pincode: this.transporterObj.pincode ? this.transporterObj.pincode.label : null,
                address: this.transporterObj.address ? this.transporterObj.address : '',
                city: this.transporterObj.city ? this.transporterObj.city : '',
                promotername: this.transporterObj.promotername ? this.transporterObj.promotername : '',
                state: this.transporterObj.state ? this.transporterObj.state : '',
                pan: this.transporterObj.pan ? this.transporterObj.pan : '',
                bankname: this.transporterObj.bankname ? this.transporterObj.bankname : '',
                bankaccountname: this.transporterObj.bankaccountname ? this.transporterObj.bankaccountname : '',
                branchname: this.transporterObj.branchname ? this.transporterObj.branchname  : '',
                accountnumber: this.transporterObj.accountnumber ? this.transporterObj.accountnumber : '',
                ifsccode: this.transporterObj.ifsccode ? this.transporterObj.ifsccode : '',
                aadhar: this.transporterObj.aadhar? this.transporterObj.aadhar : '',
                vendortype: this.transporterObj.vendortype ? this.transporterObj.vendortype : '',
                bankcancelledcheque: this.bankcancelledcheque ? this.bankcancelledcheque : '',
                gstincertificate: this.gstincertificate ? this.gstincertificate : '',
            };
            console.log("infoObj",infoObj);
        this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/InsertTransporterInfoNew`, infoObj).then((result)=>{
          document.getElementById("overlay").style.display = "none";
          if (result.body.returnmsg === "Successful") {
            this.$fire({
              text: result.body.returnvalue,
              type: "success",
              timer: 30000,
            });
            this.filter=null;
            this.currentPage=1;
            this.getTransporterList();
            this.toggleTransporterInfo();
           
          } else {
            this.$fire({
              text: result.body.returnvalue,
              type: "error",
              timer: 30000,
            });
          }
        }).catch((ex) => {
          console.log("error", ex);
        });
      },

      updateModal(data){                        
        this.addInfoCard = false
        this.updatetransporterObj={};
        this.updatetransporterObj.transporter_id=data.transporter_id
        this.updatetransporterObj.transporter_company_name =data.transporter_company_name
        this.updatetransporterObj.transporter_name =data.transporter_name
        this.updatetransporterObj.transporter_emailid =data.transporter_emailid
        this.updatetransporterObj.transporter_mobilenumber =data.transporter_mobilenumber
        this.updatetransporterObj.gstnumber=(data.transporter_gst_no=='undefined'||data.transporter_gst_no==undefined||data.transporter_gst_no==null||data.transporter_gst_no=='null'||data.transporter_gst_no==''?'':data.transporter_gst_no)
        this.updatetransporterObj.transportserviceability = data.serviceability

          this.updatetransporterObj.pincode = data.pincode  ? data.pincode.toString() : '',
          this.updatetransporterObj.address = data.address ? data.address : '',
          this.updatetransporterObj.pan = data.pan ? data.pan : '',
          this.updatetransporterObj.bankname = data.bank_name ? data.bank_name : '',
          this.updatetransporterObj.bankaccountname = data.bank_account_name ? data.bank_account_name : '',
          this.updatetransporterObj.branchname = data.bank_branch ? data.bank_branch  : '',
          this.updatetransporterObj.accountnumber = data.account_number ? data.account_number : '',
          this.updatetransporterObj.ifsccode = data.ifsc_code ? data.ifsc_code : '',
          this.updatetransporterObj.aadhar = data.adhaar? data.adhaar : '',
          this.updatetransporterObj.vendortype = data.vendortype ? data.vendortype.toLowerCase() : '';
          if (data.vendortype && data.vendortype == 'Owned') {
            this.updatetransporterObj.vendortype = 'normal'
          }
          this.updatetransporterObj.promotername = data.promotername ? data.promotername : '';
          this.updatetransporterObj.bankcancelledcheque= data.bankcancelledcheque ? data.bankcancelledcheque : '',
          this.updatetransporterObj.gstincertificate= data.gstincertificate ? data.gstincertificate : '',          
          this.updatetransporterObj.registration_url= data.registration_url ? data.registration_url: '',
          this.updatetransporterObj.puc_url = data.puc_url? data.puc_url: '',
          this.updatetransporterObj.pucnumberfile =   data.puc_url? data.puc_url.split('?key=')[1].split('-').pop(): '';          

          this.updatetransporterObj.insurance_url = data.insurance_url ? data.insurance_url : '',
          this.updatetransporterObj.permit_url = data.permit_url ? data.permit_url : '',
          this.updatetransporterObj.paymenttype = data.paymenttype ? data.paymenttype : '',
          this.updatetransporterObj.licence_url = data.licence_url ? data.licence_url : '',
          this.updatetransporterObj.labour_charges = data.labour_charges ? data.labour_charges : '',
          this.updatetransporterObj.fixed_kms = data.fixed_kms ? data.fixed_kms : '',
          this.updatetransporterObj.fixed_freightrate = data.fixed_freightrate ? data.fixed_freightrate : '',
          this.updatetransporterObj.extra_kmrate= data.extra_kmrate ? data.extra_kmrate : '',
          this.updatetransporterObj.workingdays= data.workingdays ? data.workingdays : ''    
          
          if(this.updatetransporterObj.pincode){    
            this.pincodeChange(this.updatetransporterObj.pincode) 
          }
          this.updateInfo = !this.updateInfo;

      },

      updatecheckGSTlength(value){
        if (value.length>0) {
          this.showverifybutton=true;
          document.getElementById("submitButton1").disabled = true; 
        }
        else{
          this.showverifybutton=false;
          this.updatetransporterObj.gstnumber='';
          this.update_errors_GST = false;
          this.update_errors_showGST= {};
          document.getElementById("submitButton1").disabled = false;
          this.updateremoveGST=false;
        }
      },

      updateverifyGSTNo(){
        document.getElementById("overlayModal").style.display = "block";
          const infoObj = {
            Gstin:this.updatetransporterObj.gstnumber,
          };
          console.log("infoObj",infoObj);
          this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/validateGSTNO`, infoObj).then((result)=>{
            console.log("result",result)
            document.getElementById("overlayModal").style.display = "none";
            if (result.body === "success") {
              document.getElementById("submitButton1").disabled = false;
              this.showverifybutton=false;
              this.$fire({
                text: 'Successful Verify',
                type: "success",
                timer: 30000,
              });
              this.update_errors_GST = false;
              this.update_errors_showGST.transporter_gstnumber = '';
              this.update_removeGST=false;
            } else {
              this.update_errors_GST = true;
              this.update_errors_showGST.transporter_gstnumber = 'Please Enter Valid Transporter Tin Number / GST Number';
              this.update_removeGST=true;
            }
          }).catch((ex) => {
            console.log("error", ex);
          });

        // if (this.updatetransporterObj.gstnumber) {
        //   this.update_errors_GST = true;
        //   this.update_errors_showGST.transporter_gstnumber = 'Please Enter Valid Transporter Tin Number / GST Number';
        //   this.update_removeGST=true;
        //   return false;
        // }
        // else{
        //   document.getElementById("submitButton1").disabled = false;
        // }
      },

      updateremovevalue(){
        this.showverifybutton=false;
        this.updatetransporterObj.gstnumber='';
        this.update_errors_GST = false;
        this.update_errors_showGST= {};
        document.getElementById("submitButton1").disabled = false;
        this.update_removeGST=false;
      },

      editTransporterForm(scope){
        this.$validator.validateAll(scope).then((result) => {
        if (result) {
            this.editTransporterInfo();
        }
        });
      },

      editTransporterInfo(){
        console.log(this.updatetransporterObj, 'this.updatetransporterObj');
        document.getElementById("overlayModal").style.display = "block";
        let userdata = localStorage.getItem("userData");
        let userInfo = JSON.parse(userdata);
            const infoObj = {
                transporter_id:this.updatetransporterObj.transporter_id,
                transporter_company_name:this.updatetransporterObj.transporter_company_name,
                transporter_name:this.updatetransporterObj.transporter_name,
                transporter_emailid:this.updatetransporterObj.transporter_emailid,
                transporter_mobilenumber:this.updatetransporterObj.transporter_mobilenumber,
                transporter_gstnumber:`${this.updatetransporterObj.gstnumber}`,
                transportserviceability:this.updatetransporterObj.transportserviceability,
                lastmodifiedby:`${userInfo.sysemailid}`,
                updated_from:'FTL',
                password: this.updatetransporterObj.password,
                pincode: this.updatetransporterObj.pincode ? this.updatetransporterObj.pincode.label : null,
                address: this.updatetransporterObj.address ? this.updatetransporterObj.address : '',
                city: this.updatetransporterObj.city ? this.updatetransporterObj.city : '',
                state: this.updatetransporterObj.state ? this.updatetransporterObj.state : '',
                pan: this.updatetransporterObj.pan ? this.updatetransporterObj.pan : '',
                bankname: this.updatetransporterObj.bankname ? this.updatetransporterObj.bankname : '',
                bankaccountname: this.updatetransporterObj.bankaccountname ? this.updatetransporterObj.bankaccountname : '',
                branchname: this.updatetransporterObj.branchname ? this.updatetransporterObj.branchname  : '',
                accountnumber: this.updatetransporterObj.accountnumber ? this.updatetransporterObj.accountnumber : '',
                ifsccode: this.updatetransporterObj.ifsccode ? this.updatetransporterObj.ifsccode : '',
                aadhar: this.updatetransporterObj.aadhar? this.updatetransporterObj.aadhar : '',
                vendortype: this.updatetransporterObj.vendortype ? this.updatetransporterObj.vendortype : '',
                bankcancelledcheque: this.updatetransporterObj.bankcancelledcheque ? this.updatetransporterObj.bankcancelledcheque : '',
                gstincertificate: this.gstincertificate ? this.gstincertificate : '',
                // gstinnumber: this.transporterObj.gstinnumber ? this.transporterObj.gstinnumber : ''
               
            };
            console.log(infoObj, 'infoObj@@@@@@');
            // return false;
        this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/updateTransporterInfoNew`, infoObj).then((result)=>{
          document.getElementById("overlayModal").style.display = "none";
          if (result.body.returnmsg === "successful") {
            this.$fire({
              text: result.body.returnvalue,
              type: "success",
              timer: 30000,
            });
            this.filter=null;
            this.updatetransporterObj={}
            this.updateInfo = false; 
            this.currentPage=1;
            this.getTransporterList();      
          } else {
            this.$fire({
              text: result.body.returnvalue,
              type: "error",
              timer: 30000,
            });
          }
        }).catch((ex) => {
          console.log("error", ex);
        });
      },
      getPincodeList:function(){
          var userdata = localStorage.getItem("userData");
          var userInfo = JSON.parse(userdata);

          const Obj={}
          this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getPincode`, Obj)
          .then((result)=>{
              if(result.body && result.body.returnmsg== "Successful"){
                  this.pincodeCityData = result.body.returnvalue;                    
                  for(let i=0;i<this.pincodeCityData.length;++i){
                      this.pincodes.push({
                          key:this.pincodeCityData[i].pincode,
                          label:this.pincodeCityData[i].pincode
                      })
                  }
              }
              else{
                  this.pincodes=[];
              }
          })
          .catch((ex) => {
              console.log("error", ex);
          });
      },
      pincodeChange(data) {        
      let pincode = ''
      if(data) {
        if(!data.label){
          pincode = data
        }else{
          pincode = data.label
        }      
        this.$set(this.updatetransporterObj, 'city', '');
        this.$set(this.updatetransporterObj, 'state', '');
          if (pincode) {
            const selectedPincode = this.pincodeCityData.find(
                item => item.vendorpincode == pincode
            );

              if (selectedPincode) {
                  this.$set(this.updatetransporterObj, 'city', selectedPincode.vendorcity);
                  this.$set(this.updatetransporterObj, 'state', selectedPincode.vendorstate);
              }
          }
        }
          
      },
      selectBankChequeFile(event){
            this.selectedBankCheque= event.target.files[0];            
            if (this.selectedBankCheque) {
                this.bankFileName = `${event.target.files[0].name}`; 
            }
            this.bankFileType = this.selectedBankCheque.type;
            this.uploadBankCheque(this.selectedBankCheque);
        },

        uploadBankCheque : function () {
         var userData = localStorage.getItem('userData');
         var userInfo = JSON.parse(userData);

            let data = new FormData();
            data.append('file', this.selectedBankCheque)
            axios.post(`${CONSTANTS.MIGRATION_API_URL}/uploadfiletos3`,data, 
                {
                    header : { 'Content-Type' : 'multipart/form-data'
                    }, 
                })
            .then(response => {
                if (response.data.result=='success') {
                    this.$fire({
                        text:"File Uploaded",
                        type: "success",
                        timer: 300000
                    })
                    this.bankcancelledcheque=response.data.image_url;   
                     this.updatetransporterObj.bankcancelledcheque= response.data.image_url;                 
                } else {
                    this.$fire({
                        text:"File Not Uploaded",
                        type: "error",
                        timer: 300000
                    })
                }
            })
            .catch(e => {
                console.log('Error In Upload Bank check',e);
                
            })
        
        },
        selectGstinCertficateFile(event){
            this.selectedGstinCertficate= event.target.files[0];            
            if (this.selectedGstinCertficate) {
                this.gstinCertficateFilename = `${event.target.files[0].name}`; 
            }
            this.gstinCertficateType = this.selectedGstinCertficate.type;
            this.uploadGstin(this.selectedGstinCertficate);

        },
        clearSearch() {
        this.filter = '';
          this.currentPage=1;
        this.getTransporterList();
        },

        uploadGstin : function () {
        var userData = localStorage.getItem('userData');
        var userInfo = JSON.parse(userData);

            let data = new FormData();
            data.append('file', this.selectedGstinCertficate)
            axios.post(`${CONSTANTS.MIGRATION_API_URL}/uploadfiletos3`,data, 
                {
                    header : { 'Content-Type' : 'multipart/form-data'
                    }, 
                })
            .then(response => {
                if (response.data.result=='success') {
                    this.$fire({
                        text:"File Uploaded",
                        type: "success",
                        timer: 300000
                    })
                    this.gstincertificate=response.data.image_url;                    
                } else {
                    this.$fire({
                        text:"File Not Uploaded",
                        type: "error",
                        timer: 300000
                    })
                }
            })
            .catch(e => {
                console.log('Error in upload GSTIN certificate',e);
                
            })
        
        },
        downloadFile(fileUrl) {
          
          // Open the file URL in a new tab
          if (fileUrl) {
              window.open(fileUrl, '_blank');
          } else {
            this.$fire('No file available for download!', {
                  title: 'Error',
                  variant: 'danger',
                  solid: true,
              });
          }
      }
    }
}
</script>
<style scoped>
#vehicle-transporter-modal .table {
  font-size: 0.9rem;
}
#vehicle-transporter-modal .b-card {
  background-color: #f9f9f9;
}
#vehicle-transporter-modal .badge {
  padding: 0.3em 0.5em;
  font-size: 0.8rem;
}
.custom-close {
  background-color: #FF8D2C !important;
  border-radius: 10px !important;
}

.custom-submit {
  background-color: #20a8d8 !important;
  border-color: #20a8d8 !important;
  border-radius: 10px !important;  
}
/* Make modal body scrollable if content is too long */
#view-transporter-modal .modal-body {
  max-height: 70vh;   /* restrict height */
  overflow-y: auto;   /* enable scrolling */
  padding: 1rem 1.5rem;
}

/* Section headers */
#view-transporter-modal h5 {
  font-size: 1rem;
  font-weight: 600;
  margin-top: 1rem;
  margin-bottom: 0.5rem;
  padding-bottom: 0.3rem;
  border-bottom: 1px solid #e0e0e0;
  color: #FFFFFF;
  background-color: #007bff;
  padding: 0.5rem;
  border-radius: 4px;
}

/* Row spacing */
#view-transporter-modal .row {
  margin-bottom: 0.5rem;
  font-size: 0.9rem;
}

/* Column labels */
#view-transporter-modal .col-sm-4 {
  font-weight: 600;
  color: #555;
}

/* Column values */
#view-transporter-modal .col-sm-8 {
  color: #2a2a2a;
  word-break: break-word; /* handle long text */
}

/* Links (documents like PAN, GST certificate, cheque) */
#view-transporter-modal a {
  color: #007bff;
  text-decoration: none;
}
#view-transporter-modal a:hover {
  text-decoration: underline;
}

/* Badge styling */
#view-transporter-modal .badge {
  padding: 0.4em 0.6em;
  font-size: 0.8rem;
  border-radius: 6px;
}
action-buttons {
  display: flex;
  gap: 0.5rem;       /* space between buttons */
  flex-wrap: wrap;   /* handle small screen */
}

/* All buttons uniform */
.action-buttons .btn {
  min-width: 70px;
  font-size: 0.8rem;
  font-weight: 500;
  border-radius: 6px;
  box-shadow: 0 1px 2px rgba(0,0,0,0.15);
  transition: all 0.2s ease-in-out;
}

/* Hover effect */
.action-buttons .btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 3px 6px rgba(0,0,0,0.2);
}

</style>